// extracted by mini-css-extract-plugin
export default {"formInput":"formInput__iO3FCl","controls":"controls__dtcNE1","button":"button__hK6M3A","loginLink":"loginLink__LGisi6"};